export default "__VITE_PUBLIC_ASSET__09d452a6__"